export default __webpack_public_path__ + "static/media/message.7c2b464b.svg";